module.exports = __webpack_public_path__ + "static/media/je.26b23b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/je.png
// module id = 1889
// module chunks = 0